import { render, staticRenderFns } from "./RequestShortItem.vue?vue&type=template&id=5dac5dbb&scoped=true&"
import script from "./RequestShortItem.vue?vue&type=script&lang=js&"
export * from "./RequestShortItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestShortItem.vue?vue&type=style&index=0&id=5dac5dbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dac5dbb",
  null
  
)

export default component.exports